import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { XCircle, ArrowRight, RefreshCw, HelpCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export const SubscriptionFailure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Parâmetros retornados pelo Mercado Pago
  const paymentId = searchParams.get('payment_id');
  const status = searchParams.get('status');

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-900 to-slate-900">
      <Navbar />
      
      <div className="max-w-2xl mx-auto px-6 py-16">
        <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-red-500/30 p-8 text-center">
          {/* Error Icon */}
          <div className="w-20 h-20 bg-gradient-to-r from-red-500 to-rose-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-white" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-white mb-4" data-testid="failure-title">
            Pagamento não realizado
          </h1>

          {/* Message */}
          <p className="text-slate-300 text-lg mb-6">
            Infelizmente não foi possível processar seu pagamento. 
            Isso pode acontecer por diversos motivos.
          </p>

          {/* Payment Details */}
          {paymentId && (
            <div className="bg-slate-700/50 rounded-lg p-4 mb-6 text-left">
              <h3 className="text-white font-medium mb-2">Detalhes</h3>
              <div className="space-y-1 text-sm">
                <p className="text-slate-400">
                  ID: <span className="text-white font-mono">{paymentId}</span>
                </p>
                <p className="text-slate-400">
                  Status: <span className="text-red-400 font-medium">{status || 'rejected'}</span>
                </p>
              </div>
            </div>
          )}

          {/* Possible Reasons */}
          <div className="bg-slate-700/30 rounded-lg p-4 mb-6 text-left">
            <h3 className="text-white font-medium mb-3">Possíveis motivos:</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>• Saldo insuficiente no cartão</li>
              <li>• Dados do cartão incorretos</li>
              <li>• Limite de crédito excedido</li>
              <li>• Cartão bloqueado ou vencido</li>
              <li>• Transação não autorizada pelo banco</li>
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate('/seller/planos')}
              className="bg-gradient-to-r from-indigo-500 to-purple-500 hover:opacity-90"
              data-testid="retry-btn"
            >
              <span className="flex items-center gap-2">
                <RefreshCw className="w-4 h-4" />
                Tentar Novamente
              </span>
            </Button>
            <Button
              onClick={() => navigate('/seller/dashboard')}
              variant="outline"
              className="border-slate-600 text-white hover:bg-slate-700"
            >
              <span className="flex items-center gap-2">
                Voltar ao Painel
                <ArrowRight className="w-4 h-4" />
              </span>
            </Button>
          </div>
        </div>

        {/* Help Section */}
        <div className="mt-8 bg-slate-800/30 rounded-xl p-6 border border-slate-700">
          <div className="flex items-start gap-3">
            <HelpCircle className="w-6 h-6 text-amber-400 flex-shrink-0" />
            <div>
              <h3 className="text-white font-medium mb-2">Precisa de ajuda?</h3>
              <p className="text-slate-400 text-sm">
                Se o problema persistir, entre em contato conosco pelo WhatsApp ou email. 
                Teremos prazer em ajudar a resolver sua situação.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
